export default __webpack_public_path__ + "static/media/text-test1.05ea3175.png";